<div #barChart class="app-custom-component-bar-chart"></div>
